import React, { useEffect, useState } from 'react'
import { isReverseState } from '../../../globalStates/general/reverse'
/** @jsxImportSource @emotion/react */
import { ClassNames, css } from "@emotion/react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { player1CurrentSquaresState } from '../../../globalStates/general/player1CurrentSquare';
import WarpWindow from './WarpWindow';
import { warpWindowDisplayState } from '../../../globalStates/item/warpWindowDisplay';
import HcbSwordWindow from './HcbSwordWindow';
import { hcbswordStatusState } from '../../../globalStates/item/hcbswordStatus';
import { hcbWindowDisplayState } from '../../../globalStates/item/hcbWindowDisplay';
import { bringItemState } from '../../../globalStates/item/bringItem';
import { mpState } from '../../../globalStates/general/mp';
import { selectedSquaresState } from '../../../globalStates/general/selectedSquares';
import { gameStatusInfoState } from '../../../globalStates/general/gameStatusInfo';
import { itemData, itemIdToImg, manageItemImg } from './manageItemData';
import { fieldDataState } from '../../../globalStates/general/fieldData';
import { player1HasWordsState } from '../../../globalStates/general/hasWords';
import { treasureChestState } from '../../../globalStates/item/treasureChest';
import { boolDrugonEggState } from '../../../globalStates/item/drugonEgg';
import { useItemAreaDisplayState } from '../../../globalStates/item/useItemAreaDisplay';
import { useMedia } from 'use-media';





let localMp = 50;
const Items = (props) => {
  const [isReverse, setIsReverse] = useRecoilState(isReverseState);
  const setPlayer1Square = useSetRecoilState(player1CurrentSquaresState);
  const [warpWindowDisplay, setWarpWindowDisplay] = useRecoilState(warpWindowDisplayState);
  const [hcbDisplay, setHcbDisplay] = useRecoilState(hcbWindowDisplayState);
  const [hcbSelect, setHcbSelect] = useRecoilState(hcbswordStatusState);
  const [bringItemId, setBringItemId] = useRecoilState(bringItemState);
  const setSelectedSquare = useSetRecoilState(selectedSquaresState);
  const [mp, setMp] = useRecoilState(mpState);
  // ユーザーに提示するためのゲームの状態
  const [gameStatusInfo, setGameStatusInfo] = useRecoilState(gameStatusInfoState);
  const [useItem, setUseItem] = useState([]); //　Array(item Id) の場所がtrue: 使用した
  const [itemDisplayContentes, setItemDisplayContentes] = useState();
  const [playerHasWords, setPlayerHasWords] = useRecoilState(player1HasWordsState);
  const [pointVius, setPointVius] = useRecoilState(treasureChestState);
  const fieldData = useRecoilValue(fieldDataState);
  const [boolDrugonEgg, setBoolDrugonEgg] = useRecoilState(boolDrugonEggState);
  const [useItemAreaDisplay, setUseItemAreaDisplay] = useRecoilState(useItemAreaDisplayState);

  useEffect(() => {
    localMp = mp;
  }, [mp]);

  // mpの計算を行うためにこの関数が媒介する
  const onUseItem = (itemId) => {
    // mpが足りないとき、1度しか使えないアイテムを再び使おうとしたときにreturnする。
    if (localMp - itemData[itemId].spendMp < 0 || (itemData[itemId].isOnce && useItem[itemId])) return;
    // アイテムを使ったか
    const tmpArr = [...useItem];
    tmpArr[itemId] = true;
    setUseItem(tmpArr);
    switch (itemId) {
      case 0://ハニカムソード
        setMp(localMp - itemData[0].spendMp);
        hcbSword("select");
        break;
      case 1://魔法のほうき
        setMp(localMp - itemData[1].spendMp);
        warp("select");
        break;
      case 2:// リバース
        setMp(localMp - itemData[2].spendMp);
        reverse();
        break;
      case 3://ボタンリセット
        setMp(localMp - itemData[3].spendMp);
        initSelectedSquare();
        break;
      case 7://MPポーション
        setMp(localMp + 40);
        break;

      case 8://宝箱
        setPointVius(1.7);
        break;

      case 14:
        setBoolDrugonEgg(true);
        setGameStatusInfo("進めるマスが毎ターンリセットされます。");
        setMp(localMp - itemData[14].spendMp);
        break;

      case 15://青いバラ
        setMp(localMp - itemData[15].spendMp);
        getAllWord();
        break;
    }
  }
  useEffect(() => {
    switch (hcbSelect) {
      case "warp":
        hcbSword("warp");
        break;
      case "reverse":
        hcbSword("reverse");
        break;
      case "noStatus":
        break;
      default:
        break;
    }
  }, [hcbSelect]);

  //　ハニカムソード | ワープかリバースを選べる: mode: "select", "warp", "reverse"
  const hcbSword = (mode) => {
    switch (mode) {
      case "select":
        setHcbDisplay("block");
        setHcbSelect("noStatus");
        break;
      case "warp":
        setHcbDisplay("none");
        warp("select");
        break;
      case "reverse":
        setHcbDisplay("none");
        console.log("hi")
        reverse();
        break;
    }
  }

  // 進む方向が反対になる
  const reverse = () => {
    if (isReverse) {
      setIsReverse(false);
      setGameStatusInfo("➡️");
    }
    else {
      setIsReverse(true);
      setGameStatusInfo("⬅️");
    }
  }

  // 任意の場所にワープさせる | mode: select, value
  const warp = (mode) => {
    switch (mode) {
      case "select":
        setWarpWindowDisplay("block");
        break;
      case !isNaN(mode):// 数値である場合に
        setPlayer1Square(mode); //プレイヤーを移動させる
        break;
      default:
        console.error("warp関数において予期していないmodeを確認しました。");
    }
  }

  // 全てのワードをゲットする
  const getAllWord = () => {
    let word_list = [];
    fieldData.forEach((data) => {
      if (data.isWord) {
        word_list.push(data);
      }
    })
    setPlayerHasWords(word_list);
  }


  // 進むボタンを初期化する
  const initSelectedSquare = (mode) => {
    setSelectedSquare([false, false, false]);
    setGameStatusInfo("進むボタンがリセットされました。");
  }

  const bringItemStyle = css`
    cursor: pointer;
    /* margin-left: 25px; */
    color: #555555;
    /* transform: translateX(5vw); */

    .unableUse {
      filter: opacity(35%);
    }
    img {
      margin: 10px;
      padding: 3px;
      width: 80px;
      height: 80px;
      border-radius: 20px;
      box-shadow: 0 10px 25px 0 rgba(61, 61, 61, 0.5);
    }
    p {
      text-align: center;
      margin: 0 auto;
      color: #807e7e;
      font-size: 0.7em;
    }

  `;
  const isPC = useMedia({ minWidth: 1024 });
  const itemArea = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    /* background-color: #ffffffbb; */
    /* backdrop-filter: blur(5px); */
    z-index: 2;
    margin-left: ${isPC ? "auto" : "50px"};
    margin-right: ${isPC ? "auto" : "50px"};
    margin-top: ${isPC ? "110px" : "70px"};
    width: 40vw;
    height: 150px;
    transform: translateY(-54px);
  `;

  const createBringItemDom = () => {
    let contents = [];

    for (let i = 0; i < 3; i++) {
      if (bringItemId[i] === null) break;
      // 使えないときのCSS
      if ((mp - itemData[bringItemId[i]].spendMp < 0) || (itemData[bringItemId[i]].isOnce && useItem[bringItemId[i]])) contents.push(<div css={bringItemStyle} key={"bring" + i} onClick={() => onUseItem(bringItemId[i])}><p>{itemData[bringItemId[i]].spendMp}</p><img src={itemIdToImg(bringItemId[i])} className='unableUse' /><p>{itemData[bringItemId[i]].name}</p></div>);
      else contents.push(<div css={bringItemStyle} key={"bring" + i} onClick={() => onUseItem(bringItemId[i])}><p>{itemData[bringItemId[i]].spendMp}</p><img src={itemIdToImg(bringItemId[i])} /><p>{itemData[bringItemId[i]].name}</p></div>);
    }
    return contents;
  }
  useEffect(() => {
    setItemDisplayContentes(createBringItemDom());
  }, [useItem]);
  const mpCircle = css`
    margin: 0 auto;
    color: #555;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    border: 1px solid #555;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    p {
      transform: translate(1%, -40%);
    }
    span {
      font-size: 0.8em;
      transform: translate(2%, 1px);
      background-color: white;
      width: auto;
      z-index: 1;
      text-align: center;
    }
  `;
  const itemDisplay = css`
    display: ${useItemAreaDisplay};
    /* width: 30vw; */
    /* margin: 0 auto; */
  `;
  return (
    <>
      <WarpWindow fieldData={props.fieldData} />
      <HcbSwordWindow hcbDisplay={hcbDisplay} />
      <div css={itemDisplay}>
        <div css={mpCircle}>
          <span>MP</span>
          <p>{mp}</p>
        </div>
        <div css={itemArea}>
          {itemDisplayContentes}
        </div>
      </div>
    </>
  )
}



export default Items
